import { useEffect, useRef, useState } from "react";
import { getChatSocket, disconnectChatSocket } from "../config/socketService";

const getAuthToken = (): string | null => {
  return localStorage.getItem("token");
};

export const useChatSocket = (role: string) => {
  const [isConnected, setIsConnected] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const hasJoined = useRef(false);

  useEffect(() => {
    const chatSocket = getChatSocket();
    if (!chatSocket) return;

    const token = getAuthToken();

    if (!token) {
      console.error("No authentication token found");
      return;
    }

    // Send token with connection
    chatSocket.auth = { token };

    const handleConnect = () => {
      console.log("Chat socket connected");
      setIsConnected(true);
    };

    const handleAuthenticated = (data: any) => {
      console.log("Chat authenticated:", data);
      setIsAuthenticated(true);
    };

    const handleDisconnect = () => {
      console.log("Chat socket disconnected");
      setIsConnected(false);
      setIsAuthenticated(false);
      hasJoined.current = false;
    };

    const handleConnectError = (error: Error) => {
      console.error("Socket connection error:", error.message);
      setIsConnected(false);
      setIsAuthenticated(false);
    };

    if (chatSocket.connected) {
      handleConnect();
    } else {
      chatSocket.connect();
    }

    chatSocket.on("connect", handleConnect);
    chatSocket.on("chat:authenticated", handleAuthenticated);
    chatSocket.on("disconnect", handleDisconnect);
    chatSocket.on("connect_error", handleConnectError);

    return () => {
      chatSocket.off("connect", handleConnect);
      chatSocket.off("chat:authenticated", handleAuthenticated);
      chatSocket.off("disconnect", handleDisconnect);
      chatSocket.off("connect_error", handleConnectError);
    };
  }, [role]);

  return { getChatSocket, isConnected, isAuthenticated };
};
